import { preload } from "react-dom";
import { isAddress } from "viem";
import { queryClient } from "~/src/context/ReactQueryProvider";
import { userProfileQueryOptions } from "~/src/hooks/profile/user-profile-query";
import { loadProfilePage } from "./primary-page-loaders";

export function preloadProfileRoute(address?: string): null {
  // Start page code and data in parallel with the parent wallet/layout chunks.
  // React.lazy still surfaces any module error through the route boundary.
  void loadProfilePage().catch(() => undefined);
  if (!address || !isAddress(address, { strict: false })) return null;

  const options = userProfileQueryOptions(address);
  void queryClient.prefetchQuery(options).then(() => {
    const cover = queryClient.getQueryData(options.queryKey)?.cover?.url;
    if (cover) preload(cover, { as: "image", fetchPriority: "high" });
  });
  return null;
}
